import React from 'react';

import { UserProvider, useUser } from '../../context/UserContext'
import ScrollAnimation from 'react-animate-on-scroll';
import BoxIntereses from './../causas/Intereses'
import Carrusel from './../causas/carrusel'

let CarruselContainer = ( { data } ) => {
  return (
    <section className="slider-causas">
      <div className="container">
        
        <ScrollAnimation animateIn='bounceInLeft' animateOnce={true} >
        <h3>{data.titulo}</h3>
        <span className="subtitle">{data.subtitulo}</span>
        </ScrollAnimation>
                
        <ScrollAnimation animateIn='bounceInRight' animateOnce={true} >
          <Carrusel />    
        </ScrollAnimation>
      </div>
    </section>
  )
} 

export default function ProfileNav() {
  
  const { usuario, cargandoUsuario, setCargandoUsuario, setData, login, setLogin, logout, FBLogin } = useUser();
  
  return (
    <div className="box profile_content">
      <BoxIntereses data={1} />
      <CarruselContainer data={{ titulo : 'Estas causas pueden interesarte.', subtitulo: 'Analizamos tus gustes, intereses y ubicación y estas causas podrían interesarte.'}} />
    </div>
  )
}